export default __webpack_public_path__ + "static/category-page-06ceb9c97e2ca2922d40d1ef54130cc4.png";